import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export const queryOptions_theme = (params: Parameters<typeof api.themeConfig.getBySlug>[0]) => {
  return queryOptions({
    queryKey: ["theme", params],
    queryFn: (context) =>
      extractionWrapper(api.themeConfig.getBySlug(params, { signal: context.signal })),
    placeholderData: keepPreviousData,
  });
};
